<template lang='pug'>
//- SideEffect-Record
div(:class='$style[`cc-side-effect-aisearch`]')
  div(v-if='subscribeVip !== `yes`' :class='$style[`cc-side-effect-aisearch-wrap`]')
    div(:class='$style[`cc-side-effect-aisearch-tutorial`]')
      div(:class='$style[`cc-side-effect-aisearch-tutorial-wrap`]')
        figure(:class='$style[`cc-side-effect-aisearch-tutorial-graphic`]')
          img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')
        span.font-medium 本服務、內容為VIP會員限定，請先訂閱。
        router-link.btn-extra.font-medium(
          title='升級VIP會員'
          tabindex='0' aria-label='升級VIP會員'
          :to='`/shop/subscribe`'
          :class='$style[`cc-side-effect-aisearch-tutorial-close`]') 立即訂閱

  div(v-else :class='$style[`cc-side-effect-aisearch-wrap`]')
    div(:class='$style[`cc-side-effect-aisearch-topper`]')
      header(:class='$style[`cc-side-effect-aisearch-header`]')
        span.font-medium(:class='$style[`cc-side-effect-aisearch-header-maintitle`]') 輸入問題，查詢病友相似提問
        //- div.border-gradient(:class='$style[`cc-side-effect-aisearch-header-tips`]') VIP會員限定

      div(:class='$style[`cc-side-effect-aisearch-searcher`]')
        Inputer(
          v-model='aiSearchValue'
          title='簡述您的問題與病症'
          style='width: 100%'
          :class='$style[`cc-input-area`]'
          :resetButton='false'
          :defaultValue='aiSearchValue'
          :placeholder='`麩醯胺酸如何使用`'
          :keyPressEnter='handleAiDoctorSearchBar'
          :errorRegex='aiDoctorError'
          :errorRegexInfo='aiDoctorErrorLog'
          :errorValue='aiDoctorError'
          @clearErrorMsg="(value) => {this.aiDoctorError = value[0]; this.aiDoctorErrorLog = '';}")

        button(tabindex='0' aria-label='搜尋' :class='$style[`cc-side-effect-aisearch-searcher-btn`]' @click='handleAiDoctorSearchBar')
          IconSearch(:size='24' :color='`#98a1a1`')

        span(:class='$style[`cc-side-effect-aisearch-update-tips`]') 數據最後更新：{{ `${currentDate.getFullYear()}.${currentDate.getMonth() + 1}.${currentDate.getDate()}` }}


    div(v-if='!preLoading' :class='$style[`cc-side-effect-aisearch-container`]')
      AiSolution(
        :key='`ais-${infiniteId}`'
        :isVip='true'
        :searchValue='aiSearchValue'
        :redirectRouter='`effect-ai`'
        :bpDesktop='3')




</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import IconSearch from '../../icon/Search';
import Inputer from '../common/Input';

import AiSolution from '../ai/AiSolution';

export default {
  metaInfo() {
    return {
      title: 'QA問答庫',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/aidoctor',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/aidoctor',
      }],
    };
  },

  components: {
    IconSearch,
    Inputer,
    AiSolution,
  },
  
  data() {
    return {
      currentDate: new Date(),
      preLoading: true,
      // showTutorial: true,
      aiSearchValue: '',
      aiDoctorError: false,
      aiDoctorErrorLog: '不能為空白',
      infiniteId: 1,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    handleAiDoctorSearchBar() {
      if (!this.aiSearchValue) {
        this.aiDoctorError = true;
        this.aiDoctorErrorLog = '不能為空白';
      } else {
        this.preLoading = false;
        this.infiniteId += 1;
      }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
      subscribeVip: 'user/exportUserSubscribeVip',
      // loginSubscribeValid: 'user/exportUserSubscribeValid',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectAiDoctor.scss';
</style>
